export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'Department';
export const NAME = 'InvoiceDepartment';
export const DUPLICATE_RECORD = '-999';